import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;

export const InstallPrompt = () => {
  const [evt, setEvt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem("naevo_install_dismissed")) return;
    const onPrompt = (e) => { e.preventDefault(); setEvt(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const t = isIOS() ? setTimeout(() => setShow(true), 4000) : null;
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); clearTimeout(t); };
  }, []);

  if (!show) return null;
  const dismiss = () => { localStorage.setItem("naevo_install_dismissed", "1"); setShow(false); };
  const install = async () => { if (evt) { evt.prompt(); await evt.userChoice.catch(() => {}); } dismiss(); };

  return (
    <div className="fixed bottom-4 left-4 right-20 sm:right-auto sm:max-w-sm z-40 casino-frame rounded-2xl p-4 flex items-start gap-3" data-testid="install-prompt">
      <Download className="h-5 w-5 text-gold shrink-0 mt-0.5" />
      <div className="flex-1 text-sm">
        <div className="font-casino text-gold-grad">Install Naevo Casino</div>
        {evt ? (
          <button onClick={install} className="btn-gold rounded-full px-4 py-1.5 text-xs mt-2" data-testid="install-btn">Add to Home Screen</button>
        ) : (
          <p className="text-xs text-white/70 mt-1">Tap <b>Share</b> then <b>Add to Home Screen</b> for full-screen play.</p>
        )}
      </div>
      <button onClick={dismiss} className="text-white/50 hover:text-white" data-testid="install-dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
};
